import React, { useState, useEffect } from "react";  // <-- Add this import
import { Col, Row } from "reactstrap";
import SalesChart from "components/dashboard/SalesChart";
import Feeds from "components/dashboard/Feeds";
import ProjectTables from "components/dashboard/ProjectTable";
import TopCards from "components/dashboard/TopCards";
import axiosInstance from "./request";  
import { URL } from "./api";            
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Dashboard = () => {
  const [counts, setCounts] = useState({
    "Approved Customer": 0,
    "Disbursed Loan": 0,
    "Today Customer": 0,
    "Reject Cusomter": 0,
    "Pending Customer": 0,
    "Ready for Payout Customer":0,
  });

  const navigate = useNavigate();

  useEffect(() => {
  const fetchCounts = async () => {
    try {

      const isAdmin = localStorage.getItem("isAdmin");
      const companyCode = localStorage.getItem("companyCode");
      const branchCode = localStorage.getItem("branch_code"); // your existing key

      let params = {};

      if (isAdmin === "0") {

        // If both null → normal flow
        if (!companyCode && !branchCode) {
          params.filter = false;
        }
        else {
          params.filter = true;

          if (companyCode) {
            params.companyCode = companyCode;
          }

          if (branchCode) {
            params.branchCode = branchCode;
          }
        }

      } else {
        // Admin → no filter
        params.filter = false;
      }

      const response = await axiosInstance.get(URL.COUNTS, { params });

      if (response?.data) {
        setCounts(response.data);
      }

    } catch (error) {
      console.error("Error fetching counts:", error);
    }
  };

  fetchCounts();
}, []);

useEffect(() => {

  const checkWalletPendingRequests = async () => {

    try {

      const companyCode = localStorage.getItem("companyCode");
      const branchCode = localStorage.getItem("branch_code");

      // only company login should see reminder
      if (!companyCode || branchCode) return;

      const res = await axiosInstance.get(
        `${URL.GET_REQUESTS}?companyCode=${companyCode}`
      );

      const pendingCount =
        res.data?.data?.filter((r) => r.status === "PENDING").length || 0;

      if (pendingCount > 0) {
        toast.warning(
          `⚠️ ${pendingCount} Wallet Top Up Requests Pending for Approval`
        );
      }

    } catch (err) {
      console.error("Wallet reminder error:", err);
    }
  };

  checkWalletPendingRequests();

}, []);

  return (
    <div>
      <Row>

        <Col sm="6" lg="4">
          <TopCards
            bg="bg-light-info text-info"
            title="Sales"
            subtitle="Today Customer"
            earning={counts["Today Customer"]}
            icon="bi bi-bag"
          />
        </Col>

         <Col sm="6" lg="4">
          <TopCards
            bg="bg-light-success text-success"
            title="Profit"
            subtitle="Pending Customer"
            earning={counts["Pending Customer"]}
            icon="bi bi-wallet"
            onClick={() => navigate("/CustomerList?status=active")} // <-- Add navigation
          />
        </Col>

        <Col sm="6" lg="4">
          <TopCards
            bg="bg-light-success text-success"
            title="Profit"
            subtitle="Approved Customer"
            earning={counts["Active Customer"]}
            icon="bi bi-wallet"
            onClick={() => navigate("/CustomerList?status=active")} // <-- Add navigation
          />
        </Col>

          <Col sm="6" lg="4">
          <TopCards
            bg="bg-light-warning text-warning"
            title="New Project"
            subtitle="Ready for Payout Customer"
            earning={counts["Ready for Payout"]}
            icon="bi bi-basket3"
            onClick={() => navigate("/DisbursementList?status=disbursed")} // ✅ navigate to reject loans tab
          />
        </Col>

        <Col sm="6" lg="4">
          <TopCards
            bg="bg-light-danger text-danger"
            title="Refunds"
            subtitle="Disbursed Loan"
            earning={counts["Disbursed Loan"]}
            icon="bi bi-coin"
            onClick={() => navigate("/DisbursementList?status=disbursed")} // ✅ Add this
          />
        </Col>

        <Col sm="6" lg="4">
          <TopCards
            bg="bg-light-warning text-warning"
            title="New Project"
            subtitle="Reject Customer"
            earning={counts["Reject Cusomter"]}
            icon="bi bi-basket3"
            onClick={() => navigate("/RejectLoanList")} // ✅ navigate to reject loans tab
          />
        </Col>

      </Row>

      <Row>
        <Col sm="6" lg="6" xl="7" xxl="8">
          <SalesChart />
        </Col>
        <Col sm="6" lg="6" xl="5" xxl="4">
          <Feeds />
        </Col>
      </Row>

      <Row>
        <Col lg="12">
          <ProjectTables />
        </Col>
      </Row>
      <ToastContainer
  position="top-right"
  autoClose={4000}
/>
    </div>
  );
};

export default Dashboard;

